export default "__VITE_ASSET__1485ad4a__"